<app-slider></app-slider>
<section class="about-section py-5">
  <div class="container">
    <div class="row align-items-center">
      <!-- Imagen -->
      <div class="col-lg-6 mb-4 mb-lg-0">
        <a href="https://divlec.com.ar" target="_blank" rel="noopener noreferrer">
          <img src="https://images.unsplash.com/photo-1521791136064-7986c2920216?w=1200" alt="Equipo Divlec"
            class="img-fluid rounded shadow" />
        </a>
      </div>

      <!-- Texto -->
      <div class="col-lg-6">
        <h1 class="display-5 fw-bold mb-3 text-primary">Quiénes somos</h1>
        <p class="lead text-muted">
          En <strong>Divlec</strong> creemos que cada problema tiene una solución.
          Nuestra historia comenzó hace más de <strong>15 años</strong>, cuando
          Lucas e Iván, trabajando como técnicos, se encontraron con una pregunta clave:
          <em>¿por qué no contar con repuestos de calidad y disponibles al instante?</em>
        </p>
        <p>
          De ese desafío nació Divlec, una empresa dedicada a la
          <strong>reparación de equipos informáticos</strong> y a la
          <strong>importación de repuestos</strong> originales y alternativos como
          displays, teclados, cargadores, baterías y mucho más.
        </p>
        <p>
          Hoy, después de años de experiencia y compromiso, seguimos creciendo con
          la misma misión:
          <strong>brindar confianza, calidad y soluciones rápidas</strong> para que
          tu equipo vuelva a funcionar como el primer día.
        </p>
      </div>
    </div>
  </div>
</section>
<app-footer [conf]="conf"></app-footer>